import { toWords } from "number-to-words";

const toWordsUtils = (number) => {
  console.log('Number: ',number); 
  const words = toWords(number);
  const capitalize = words.charAt(0).toUpperCase() + words.slice(1);
  return capitalize;
}

export default toWordsUtils;